var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _vm.showTabVehiculos
            ? _c("v-tab", { attrs: { href: "#tab-2", to: "/vehiculos" } }, [
                _vm._v("Vehículos")
              ])
            : _vm._e(),
          _vm.showTabFlotas
            ? _c("v-tab", { attrs: { href: "#tab-3", to: "/flotas" } }, [
                _vm._v("Flotas")
              ])
            : _vm._e(),
          _c("v-tab", { attrs: { href: "#tab-1" } }, [_vm._v("GPS")]),
          _vm.showTabSIM
            ? _c("v-tab", { attrs: { href: "#tab-4", to: "/sim" } }, [
                _vm._v("SIM")
              ])
            : _vm._e()
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "0px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm6: "",
                md4: _vm.accionCrear.visible,
                md6: !_vm.accionCrear.visible
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "15px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionExportar.visible
                    ? _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.exportar()
                            }
                          }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n          "),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md2: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" },
                  attrs: { align: "right" }
                },
                [
                  _vm.accionCrear.visible
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-crear",
                          staticStyle: { "padding-right": "20px" },
                          on: {
                            click: function($event) {
                              ;(_vm.editedItem = {}), (_vm.showModalNew = true)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { staticStyle: {}, attrs: { dark: "", left: "" } },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", [_vm._v("Crear")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "v-layout",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.muestraBarraBotones,
              expression: "muestraBarraBotones"
            }
          ],
          staticClass: "animated fadeIn fast",
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "div",
            [
              _c(
                "v-flex",
                { attrs: { md2: "" } },
                [
                  _vm.accionEliminar.visible
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn-barra",
                          attrs: { flat: "", small: "" },
                          on: { click: _vm.eliminarSeleccionadas }
                        },
                        [
                          _c("v-icon", [_vm._v("delete")]),
                          _vm._v("  Eliminar Seleccionadas\n        ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogEliminar,
          titulo: _vm.tituloEliminar,
          mensaje: _vm.mensajeEliminar,
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.deleteItemCallback($event)
          }
        }
      }),
      _c("app-gps-modal-nuevo", {
        attrs: { show: _vm.showModalNew, gps: _vm.editedItem },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.gpsModalCallback($event)
          }
        }
      }),
      _c("app-gps-modal-edicion", {
        attrs: {
          show: _vm.showModalEdit,
          esEdicion: _vm.modalEsEdicion,
          gps: _vm.editedItem
        },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.gpsModalCallback($event)
          }
        }
      }),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "480" },
              model: {
                value: _vm.mostrarAvisoDelete,
                callback: function($$v) {
                  _vm.mostrarAvisoDelete = $$v
                },
                expression: "mostrarAvisoDelete"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticStyle: {
                            "font-size": "17px",
                            "margin-left": "10px !important"
                          }
                        },
                        [_vm._v(_vm._s(_vm.titulomostrarAvisoDelete))]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.mostrarMensajeDelete
                    ? _c("v-card-text", [
                        _c("span", [_vm._v(_vm._s(_vm.textoMensajeDelete))])
                      ])
                    : _vm._e(),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.eliminarMasivoMensajes = []
                              _vm.mostrarAvisoDelete = false
                            }
                          }
                        },
                        [_vm._v("Aceptar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }